import script from "./InsertTableWizard.vue?vue&type=script&setup=true&lang=ts"
export * from "./InsertTableWizard.vue?vue&type=script&setup=true&lang=ts"

import "./InsertTableWizard.vue?vue&type=style&index=0&id=6c2ca58a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c2ca58a"]])

export default __exports__